import { useState } from 'react';

// mui
import { Box, Divider } from '@mui/material';

// components
import { HomeImages, PostView, RecommendFilter } from '../';

// api
import { Like } from '../../api';

// client-shared
import { def } from '@goldblack/shared';
import { storage } from '@goldblack/client-storage';

function HomeBody(props) {
    //const privacy = storage.transience.getValue('privacy');
    const recommendFilter = storage.transience.getValue('filter.recommend.selected');
    const vecMode = (() => {
        for (const f of recommendFilter) {
            try {
                const v = String(JSON.parse(f.value)?.[0] ?? '').toLowerCase();
                if (v === 'favorites' || v === 'following') return v;
            } catch {}
        }
        return 'both';
    })();
    const [subKey, setSubKey] = useState('global');
    const feedKey = `${vecMode}:${subKey}`;
    const [openFilter, setOpenFilter] = useState(false);
    const [openPostView, setOpenPostView] = useState(false);
    const [openComment, setOpenComment] = useState(false);
    const [post, setPost] = useState(null);
    const [user, setUser] = useState(null);

    const onClickComment = (post) => {
        if (post.post && post.user) {
            setOpenPostView(true);
            setPost(post.post);
            setUser(post.user);
            setOpenComment(true);
        }
    };

    const onClickLike = () => {
        Like(post, (liked, likes) => {
            setPost((prevState) => ({ ...prevState, liked, likes }));
        });
    };

    const onCommentsChanged = (comments) => {
        setPost((prev) => ({ ...prev, comments }));
    };

    const onClose = () => {
        setOpenPostView(false);
        setOpenComment(false);
    };

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
            <RecommendFilter open={openFilter} onToggle={() => setOpenFilter((o) => !o)} setFilters={setSubKey} />
            <Divider orientation='horizontal' variant='fullWidth' sx={{ borderColor: 'primary.dark', flexShrink: 0 }} />
            <Box sx={{ flex: 1, minHeight: 0 }}>
                <HomeImages
                    {...props}
                    vecMode={vecMode}
                    subKey={subKey}
                    feedKey={feedKey}
                    onClickComment={onClickComment}
                    onFirstBatch={() => setOpenFilter(false)}
                />
            </Box>

            {/*===== post dialog =====*/}
            {openPostView && (
                <PostView
                    open={openPostView}
                    post={post}
                    user={user}
                    config={props.config}
                    onClose={onClose}
                    onClickLike={onClickLike}
                    onCommentsChanged={onCommentsChanged}
                    onReport={() => setPost((prev) => ({ ...prev, status: def.PostStatus.PROCESSING }))}
                    openComment={openComment}
                />
            )}
        </Box>
    );
}

export { HomeBody };
